export function EmptyOptionsNote() {
  return <p className="text-xs text-muted-foreground">No options defined.</p>;
}
